import { NavLink } from "react-router-dom";
import { AdminThemeToggle } from './adminTheme';
import { FiCalendar, FiFileText, FiImage, FiBarChart2, FiUser, FiExternalLink, FiLogOut } from 'react-icons/fi';
import AdminIconButton from './AdminIconButton';
import AdminNotice, { AdminNotifications } from './AdminNotice';

const sections = [
  { to: "/admin/lessons", label: "Lesson Requests", icon: FiCalendar },
  { to: "/admin/about", label: "About page", page: "about", icon: FiUser },
  { to: "/admin/presskit", label: "Press Kit copy", page: "presskit", icon: FiFileText },
  { to: "/admin/media", label: "Media library", icon: FiImage },
  { to: "/admin/media-kit", label: "Media Kit", page: "mediakit", icon: FiBarChart2 },
];

export default function AdminLayout({ children, dirtyPages, email, onDismissStatus, onSignOut, status, theme, onToggleTheme }) {
  return (
    <main className="admin-page" data-theme={theme}>
      <AdminNotifications />
      <header className="admin-topbar">
        <div className="admin-brand"><p className="admin-kicker">Website management</p><h1>Ken & Bryn Admin</h1></div>
        <div className="admin-account"><span>{email}</span><div className="admin-account-tools"><AdminThemeToggle theme={theme} onToggle={onToggleTheme} /><a className="admin-icon-button" href="/" target="_blank" rel="noopener noreferrer" aria-label="View website" title="View website (opens a new tab)"><FiExternalLink aria-hidden="true" /></a><AdminIconButton label="Sign out" icon={FiLogOut} onClick={onSignOut} /></div></div>
      </header>

      <div className="admin-dashboard">
        <aside className="admin-sidebar">
          <p>Manage</p>
          <nav className="admin-nav" aria-label="Admin navigation">
            {sections.map((section) => (
              <NavLink key={section.to} to={section.to} className={({ isActive }) => isActive ? "active" : undefined}>
                <section.icon aria-hidden="true" /><span className="admin-nav-label">{section.label}</span>
                {section.page && dirtyPages.has(section.page) && <span className="admin-dirty-dot" aria-label="Unsaved changes" />}
              </NavLink>
            ))}
          </nav>
        </aside>

        <section className="admin-workspace">
          <AdminNotice text={status.message} type={status.type} onDismiss={onDismissStatus} />
          {children}
        </section>
      </div>
    </main>
  );
}
